/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebsitImageTypeReqVo
 */
export interface WebsitImageTypeReqVo {
    /**
     * 编码
     * @type {number}
     * @memberof WebsitImageTypeReqVo
     */
    code?: number;
    /**
     * 名称
     * @type {string}
     * @memberof WebsitImageTypeReqVo
     */
    name?: string;
}

/**
 * Check if a given object implements the WebsitImageTypeReqVo interface.
 */
export function instanceOfWebsitImageTypeReqVo(value: object): value is WebsitImageTypeReqVo {
    return true;
}

export function WebsitImageTypeReqVoFromJSON(json: any): WebsitImageTypeReqVo {
    return WebsitImageTypeReqVoFromJSONTyped(json, false);
}

export function WebsitImageTypeReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebsitImageTypeReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function WebsitImageTypeReqVoToJSON(json: any): WebsitImageTypeReqVo {
    return WebsitImageTypeReqVoToJSONTyped(json, false);
}

export function WebsitImageTypeReqVoToJSONTyped(value?: WebsitImageTypeReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

